export default {
    lang: "no",
    get: function(key) {
        return this[key][this.lang];
    },
    showMoreHits: {
        no: "Vis flere treff",
        nn: "Vis fleire treff",
        en: "Show more"
    },
    hits: {
        no: "treff",
        nn: "treff",
        en: "hits"
    },
    noHits: {
        no: "Ingen treff",
        nn: "Ingen treff",
        en: "No hits"
    },
    showing: {
        no: "viser",
        nn: "visar",
        en: "showing"
    },
    showMoreCategories: {
        no: "Vis flere kategoriar",
        nn: "Vis flere kategorier",
        en: "Show more categories"
    },
    search: {
        no: "Søk",
        nn: "Søk",
        en: "Search"
    },
    categories: {
        no: "kategorier",
        nn: "kategorier",
        en: "categories"
    },
    period: {
        no: "periode",
        nn: "periode",
        en: "period"
    },

    // Carousel
    previous: {
        no: "Forrige",
        nn: "Forrige",
        en: "Previous"
    },
    next: {
        no: "Neste",
        nn: "Neste",
        en: "Next"
    },
    fullscreen: {
        no: "Fullskjerm",
        nn: "Fullskjerm",
        en: "Fullscreen"
    },
    download: {
        no: "Last ned",
        nn: "Last ned",
        en: "Download"
    },
    zoomIn: {
        no: "Zoom inn",
        nn: "Zoom inn",
        en: "Zoom in"
    },
    zoomOut: {
        no: "Zoom ut",
        nn: "Zoom ut",
        en: "Zoom out"
    },
    close: {
        no: "Lukk",
        nn: "Lukk",
        en: "Close"
    },
    // Filter
    choose: {
        no: "Velg",
        nn: "Velg",
        en: "Choose"
    },
    license: {
        no: "Lisens",
        nn: "Lisens",
        en: "License"
    },
    licenseOnPhoto: {
        no: "Lisens på fotografi",
        nn: "Lisens på fotografi",
        en: "License on photo"
    },
    copyright: {
        no: "Opphavsrett",
        nn: "Opphavsrett",
        en: "copyright"
    },
    contactOwner: {
        no: "Kontakt eier for mer informasjon",
        nn: "Kontakt eier for mer informasjon",
        en: "Contact owner for more information"
    },
    searchPlaceholderMinChars: {
        no: "Minst tre tegn",
        nn: "Minst tre teikn",
        en: "At least three characters"
    },
    series: {
        no: "Serie",
        nn: "Serie",
        en: "Series"
    }
};
